// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"224":"cb2417205cd6047d","966":"2b1efb9e2c9f1c43","992":"afc7067cfaab136e"}[chunkId] + ".js";
};